import { applyComponentTheme } from '../../../theme';
import { PageArrowButton } from './styles';

export default applyComponentTheme(PageArrowButton, 'PageArrow');
